import React from "react";

const IncomeTax = () => {
    return <div>IncomeTax</div>
}

export default IncomeTax;